module.exports = __webpack_public_path__ + "img/c_2.c68bc826.png";